import { z } from "zod";

import { apiGet } from "../lib/api";

export const CredentialsResponseSchema = z.object({
  access_key_id: z.string(),
  secret_access_key: z.string(),
  session_token: z.string(),
  expiration: z.string(),
  region: z.string(),
  endpoint: z.string(),
});
export type IotCredentials = z.infer<typeof CredentialsResponseSchema>;

export function fetchIotCredentials() {
  return apiGet("/api/iot/credentials", CredentialsResponseSchema);
}
